import { Box, Paper, styled, Popper } from '@mui/material';

export const DropdownItemContainer = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  fontSize: '14px',
  position: 'relative',
  transition: 'all 150ms linear',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: theme.spacing(0.5),
  color: theme.palette.grey,
  '&:hover': {
    backgroundColor: theme.palette.background.default
  }
}));

export const NotificationPaper = styled(Paper)(({ theme }) => ({
  paddingBlock: theme.spacing(0.5),
  paddingInline: theme.spacing(1)
}));

export const NotificationAnchorContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  cursor: 'pointer',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center'
  }
}));

export const NotificationLoaderContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(-1),
  width: '100%'
}));

export const NotificationsBoxContainer = styled(Box)(({ theme }) => ({
  maxHeight: '200px',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    width: '0.4rem',
    backgroundColor: 'rgb(243 244 246)'
  },
  '&&::-webkit-scrollbar-thumb': {
    borderRadius: theme.spacing(1.5),
    backgroundColor: 'rgb(209 213 219)'
  },
  /* For Firefox and other browsers that don't support -webkit-scrollbar */
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgb(209 213 219) rgb(243 244 246)'
}));

export const NotificationPopper = styled(Popper)(() => ({
  zIndex: '99999'
}));
